import React, {useState, useContext, useEffect, useRef } from 'react';
import { IonCard, IonInput, IonText, IonLabel, IonSlides, IonSlide, IonImg, IonModal, IonGrid, IonRow, IonCol, IonButton, IonCardContent, IonContent, IonHeader, IonFooter, IonToolbar, IonLoading } from '@ionic/react';

import {v4 as uuid} from 'uuid';

import './Reservation_EnterBookingInfo_locals.css';
import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import { MerchantLoginCredentials } from './LoginCredentials_merchant';
import {RegisterIndividualModal} from './Register_Individual_Modal';

import { useHistory} from "react-router-dom";

export function PayModal_Retail (props) {

    let authMerchant_objects = useContext(Auth_MerchantID_context);

    const [companyID, setCompanyID ] = useState(props.data.companyId);
    const [acctID, setAcctID ] = useState(authMerchant_objects.acctID);
    let [authenticated, setIsAuthenticated] = useState(authMerchant_objects.authenticated);
    let [sessionID, setSessionID ] = useState('public_session');
    let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);

    let [ccInfoDisplay, setCCInfoDisplay ] = useState('none');
    let [mmInfoDisplay, setMMInfoDisplay ] = useState('inline-block');
    let [checkingInfoDisplay, setCheckingInfoDisplay ] = useState('none');
    let [cashInfoDisplay, setCashInfoDisplay ] = useState('none');
    
    let [checkInMemberPaymentType, setCheckInMemberPaymentType ] = useState('cash');
    let [checkInNonMemberPaymentType, setCheckInNonMemberPaymentType ] = useState('mm');
    let [checkInCustomerStatus, setCheckInCustomerStatus ] = useState('member');


    let [bookedStartDate, setBookedStartDate] = useState(props.data.bookedStartDate);
    let [bookedEndDate, setBookedEndDate] = useState(props.data.bookedEndDate);

    let [disablePayButton, setDisablePayButton] = useState(false);
    let [isloading, setLoading] = useState(false);

    let [merchantLoginModal, setMerchantLoginModal] = useState(false);
    let [registerModal_individial, setRegisterModal_individual] = useState(false);

    let [username, setUsername] = useState('');
    let [password, setPassword] = useState('');

    let [saveEvent, setSaveEvent] = useState([]);

    let history = useHistory();

    let [checkInAttachment_ID, setCheckInAttachment_ID ] = useState(() => {

        let noImageFile = new File([''], '/var/www/web/Public/fileServer/merchants/image-not-available.jpg', {
            enctype: 'multipart/form-data',
            type: 'file',
            name: 'xImageFile',
            accept: "image/*",
          });

          return noImageFile;
        
    });



/*function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}*/     


/*const fetchData = async (xReferenceID) => {
    const url = 'https://sandbox.momodeveloper.mtn.com/v1_0/apiuser';
    const headers = {
        'Content-Type': 'application/json',
        'X-Reference-Id': xReferenceID.toString(),
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Ocp-Apim-Subscription-Key': '85fbd2d4d1994f6a93c7373ad5c133ca',
    };

    try {
      const response = await Http.post({
        url,
        headers,
        data: {         
            providerCallbackHost: "https://bluefinhoteltest.com/mtn_callbacks"    
        }, // Your request payload
      });

      console.log(response.data);
    } catch (error) {
      console.error(error);
    }
  };*/



function submitPay(event, authenticatedAccount, acctID)
{

    //alert("IN SUBMIT PAY")

    // alert(companyID);
    // alert(props.data.companyId);
    // alert(authenticatedAccount);
    //alert(acctID);
    // alert(props.data.mtnCompanyPhoneNumber);

    setLoading(true);
    let xReferenceID = uuid();

    if (props.data.paymentType == 'cash'|| props.data.paymentType == 'CASH')
    {
        prepareInvoice_thenConfirmPay_nonMember([event, props.data.paymentType, undefined, undefined, xReferenceID.toString(),,,,,,,,acctID]);

        return;
    }

            const customerPayAmount = parseFloat(props.data.payment_amount).toFixed(2);

            const payCurrency = 'GHS';
            //const payExternalId = '';
            const payPartyId = props.data.mobileNumber.replace(/^0+/, '');
            const payPayerMessage = props.data.payeeMessage;
            const payPayeeNote = props.data.firstName + ' ' + props.data.lastName + ' Payment';

            const apiuser = "824b5de8-0af9-4757-939b-f50992a0427f";
            const apikey = "e288a3938db14c8c9dfe3543427a141e";
            const concatenatedString = `${apiuser}:${apikey}`;
            const base64EncodedString = window.btoa(concatenatedString);


            //let xReferenceID = uuid();

            //alert('BEFORE FETCH');
            //alert(props.data.companyPhoneNumber.replace(/^0+/, ''));


            fetch(baseURL+'mtnapi/collection/token/', {
                method: 'POST',                                                                                                                                                                                                                 
                credentials: 'include',
                //mode: 'no-cors',
                //body: '',
                //Request headers
                headers: {
                    'authorization': 'Basic '+ base64EncodedString,
                    //'cache-Control': 'no-cache',
                    //'content-_type': 'application/json',
                    'ocp-apim-subscription-key': 'c4f861935bb543cbba9f3762cf13fd9e',
                    'x-target-environment': 'mtnghana',
                    'x-reference-id': xReferenceID.toString(),
                    'x-internal-reference-id': xReferenceID.toString(),
                    'tracker': '74108_B_update_successful_retail',
                    'user': acctID,
                    'x_company_id_public': companyID,
                    'x_merchant_mobilenumber': props.data.mtnCompanyPhoneNumber.replace(/^0+/, ''),
                    'x_ProjectID': "N/A",
                    'x_customer_mobilenumber': event[3],
                    'x_invoice_id': event[1],
                    'x_customer_invoice_id': event[2],
                    'x_immediate_destination': companyID,
                    'x_check_in_amount': parseFloat(event[5]).toFixed(2),
                    'session_id': sessionID,
                    'momo_url': 'collection/v1_0/requesttopay',
                    'confirm_payment': 'confirm_or_reject',
                    // 'request_to_pay': JSON.stringify({
                    //     "amount": customerPayAmount,
                    //     "currency": payCurrency,
                    //     "externalId": xReferenceID.toString(),
                    //     "payer": {
                    //         "partyIdType": "MSISDN",
                    //         "partyId": "233"+payPartyId
                    //     },
                    //     "payerMessage": payPayerMessage,
                    //     "payeeNote": payPayeeNote
                    // }),
                    'customer_pay_amount': customerPayAmount,
                    'pay_currency': payCurrency,
                    'external_id': xReferenceID.toString(),
                    'party_id_type': 'MSISDN',
                    'party_id': payPartyId,
                    'pay_payer_message': payPayerMessage,
                    'pay_payee_note': payPayeeNote,

                },

            })
            .then(res => res.json())
            .then(res => {

                    // alert("After Momo Pay")
                    // alert(res)
                    if(res == "MTN_ERROR")
                    {
                        alert("ERROR PROCESSING REQUEST.  PLEASE TRY AGAIN")
                        return;
                    }
                    else
                    {
                        prepareInvoice_thenConfirmPay_nonMember([event, props.data.paymentType, 'MTN', res.financialTransactionId, xReferenceID.toString(), res.amount, 'GHS', res.payer.partyIdType, res.payer.partyId, res.payerMessage, res.payeeNote, res.status, acctID]);
                    }
                  
            })

    

}

function prepareInvoice_thenConfirmPay_nonMember(event)
    {

          //alert("IN PREPAREiNVOICE")
          //alert(event);
        //  alert(event[0][14]);
        //  alert(event[0][6]);
        //  alert(event[0][7]);
        //  alert(event[0][8]);
        //  alert(event[0][9]);
        //  alert(event[0][10]);

        if(event[0][14] == "initial")
        {       
            /*alert("after event[0][14]");
            alert(event);
            alert(event[0][6]);
            alert(event[0][7]);
            alert(event[0][8]);
            alert(event[0][9]);
            alert(event[0][10]);
            alert(checkInNonMemberPaymentType);
            alert(parseFloat(event[5]).toFixed(2));
            alert(checkInAttachment_ID);
            alert(props.data.numOfNights);
            alert(props.data.bookingID);
            alert(bookedStartDate);
            alert(bookedEndDate);
            alert(sessionID);*/
            //alert(props.data.companyId);


            //alert(event[12]);

            const requestOptions0 = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74706_checkoutDeposit_retail_public',
                    user: event[12],
                    //user: acctID,
                    xCompanyID_public: props.data.companyId,
                    xCartList: event[0][6],
                    xCartFirstName: event[0][7],
                    xCartLastName: event[0][8],
                    xCartMobileNumber: event[0][9],
                    xCartEmail: event[0][10],
                    sessionID: sessionID,
                    xCartNonMemberPaymentType: props.data.paymentType,
                    xUserStatus: checkInCustomerStatus,
                    xCartSubtotal: props.data.cartSubtotal,
                    xCartCheckoutTotal: props.data.cartCheckoutTotal,
                    xCartLatitude: props.data.cartLatitude,
                    xCartLongitude: props.data.cartLongitude,
                    xStorefront: props.data.storefront,
                    xReference_externalID: event[4],
    
                }),
            }
    
            //alert("IN PREPAREiNVOICE 2")
            //alert(baseURL)

            fetch(baseURL+'ghanaverified_retail/', requestOptions0)
            //fetch('https://bluefinhoteltest.com/public_to_internal_retail/', requestOptions0)
            .then(res => res.text())
            .then(data0 => {
    
                //alert(" AFTER PREPAREiNVOICE 2");
                //alert(data0);
                            let rows = data0.toString().split('~~~');
                            let cols = rows[0].split('|');
                            let cols_user = rows[1].split('|');


                            const requestOptions = {
                                method: 'POST',
                                //credentials: 'include',
                                headers: {
                                    'Accept': 'text/html, application/json',
                                    'content-type': 'application/json',
                                    //'cookie': 'cookie',
                                },
                                body: JSON.stringify({
                                    Tracker: '74108_B_expense',
                                    user: event[12],
                                    //user: acctID,
                                    xCompanyID_public: props.data.companyId,
                                    xCustMobileNumber: event[0][3],
                                    xInvoiceID: cols[0],
                                    xZInvoiceID: cols[3],
                                    xCustomerInvoiceID: cols[1],
                                    xImmediateDestination: props.data.companyId,
                                    xCheckInCashAmount: parseFloat(event[0][5]).toFixed(2),
                                    sessionID: sessionID,
                                    xPaymentType: event[1],
                                    xUserStatus: checkInCustomerStatus,
                                    xMomo_provider: event[2],
                                    xMomo_financial_transaction_id: event[3],
                                    xMomo_external_id: event[4],
                                    xMomo_amount: event[5],
                                    xMomo_currency: event[6],
                                    xmomo_party_id_type: event[7],
                                    xMomo_party_id: event[8],
                                    xMomo_payer_message: event[9],
                                    xMomo_payee_note: event[10],
                                    xMomo_pay_status: event[11], 
                                    //xReference_externalID: event[4],
                                    xInternalReferenceID: cols[4],
                                    //xOrderID: cols[2],
          
                    
                                }),
                            }
    
                            fetch(baseURL+'ghanaverified/', requestOptions)
                            .then(res => res.text())
                            .then(data => {

                                confirmPayment_non_member([data, event[0][1], cols[1], event[0][3], event[0][4], event[0][6], event[1], event[2], event[3], cols[4], event[5], event[6], event[7], event[8], event[9], event[10], event[11], cols[2], cols[0], cols[3], event[12], cols_user[2]]);
    
                            })
                            .catch(error => {
                                console.error(error);
                            })
    
                })
        }

    }

    let intervalID;

    function confirmPayment_non_member(event)
    {
        // alert("in Confrim Payment - nonmember");
        // alert(event);
        // alert(event[6]);

        let transactionID = event[0];
        let customerInvoiceID = event[2]; //undefined
        let customerPhoneNumber = event[3];
        let tracker = event[4];
        let xReferenceID = event[9];

        // alert("Event 0 is - "+event[0]);
        // alert("Event 1 is - "+event[1]);
        // alert("Event 2 is - "+event[2]);
        // alert("Event 3 is - "+event[3]);
        // alert("Event 4 is - "+event[4]);
        // alert("Event 5 is - "+event[5]);
        // alert("Event 6 is - "+event[6]);
        // alert("Event 7 is - "+event[7]);
        // alert("Event 8 is - "+event[8]);
        // alert("Event 9 is - "+event[9]);
        // alert("Event 10 is - "+event[10]);
        // alert("Event 11 is - "+event[11]);
        // alert("Event 12 is - "+event[12]);
        // alert("Event 13 is - "+event[13]);
        // alert("Event 14 is - "+event[14]);
        // alert("Event 15 is - "+event[15]);
        // alert("Event 16 is - "+event[16]);
        //alert("Event 17 is - "+event[17]);

        /*
        let formData = new FormData();
        formData.append('Tracker', tracker);
        formData.append('xCustomerInvoiceID', customerInvoiceID);
        formData.append('xTransactionID', transactionID);
        formData.append('xCustMobileNumber', customerPhoneNumber);
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', event[5]);
        formData.append('xCartID', props.data.bookingID);

        const requestOptions = {
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        //alert(event[20]);

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: tracker,
                baseUrl: baseURL,
                user: event[20],
                xCompanyID_public: props.data.companyId,
                xInvoiceID: event[18],
                xZInvoiceID: event[19],
                xCustomerInvoiceID: customerInvoiceID, //undefined
                xTransactionID: transactionID,
                xCustMobileNumber: customerPhoneNumber,
                xOrderID: event[17],
                sessionID: sessionID,
                xPaymentType: event[6],
                xUserStatus: checkInCustomerStatus,
                xMomo_provider: event[7],
                xMomo_financial_transaction_id: event[8],
                xMomo_external_id: event[9],
                xMomo_amount: event[10],
                xMomo_currency: event[11],
                xmomo_party_id_type: event[12],
                xMomo_party_id: event[13],
                xMomo_payer_message: event[14],
                xMomo_payee_note: event[15],
                xMomo_pay_status: event[16],
                xInternalReferenceID: xReferenceID,


            }),
        }

        fetch(baseURL+'ghanaverified/', requestOptions)
        .then(res => res.text())
        .then(data => {

            //alert("before loading");
            //alert("INITIAL PAYMENT REQUEST SENT.  PENDING CUSTOMER APPROVAL.");
            //alert(data);

            // if(isloading == true)
            // {
            //     alert("Please approve MTN momo request");
            //     setTimeout(getMomoStatus(transactionID), 5000);

                intervalID = setInterval(() => {                                
                                    
                                            const requestOptions = {
                                                method: 'POST',
                                                //credentials: 'include',
                                                headers: {
                                                    'Accept': 'text/html, application/json',
                                                    'content-type': 'application/json',
                                                    //'cookie': 'cookie',
                                                },
                                                body: JSON.stringify({
                                                    Tracker: '74605_B_retail_public_check_payStatus',
                                                    user: event[20],
                                                    xCompanyID_public: props.data.companyId,
                                                    xTransactionID: transactionID,
                                                    sessionID: sessionID,
                                                    
                                                }),
                                            }
                                    
                                            fetch(baseURL+'ghanaverified/', requestOptions)
                                            .then(res => res.text())
                                            .then(data => {
                                                                        
                                                let rows = data.toString().split('~~~');
                                                //clearInterval(intervalID);

                                                
                                                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                                                {
                                                    let cols = rows[rownum].split('|');
                                    
                                                    if(cols[1] == "C" && cols[2] == "SUCCESSFUL")
                                                    {

                                                        //alert('PAYMENT SUCESSFUL.  YOU SHOULD RECIEVE INVOICE VIA TEXT.  YOUR RETAIL INVOICE ID IS '+cols[0]);

                                                        clearInterval(intervalID);

                                                        setLoading(false);

                                                        authMerchant_objects.changeAuthenticated(authenticated);

                                                        //merchantLoginModal(false);
                                                        //history.push('/home');

                                                        props.closeModal([cols[2], event[17], event[21], event[20], cols[0]]);

                                                    }
                                                    else if(cols[1] == "PC" && cols[2] == "CASH")
                                                    {

                                                        alert('CASH PAYMENT PENDING MERCHANT APPROVAL');

                                                        clearInterval(intervalID);

                                                        setLoading(false);

                                                        authMerchant_objects.changeAuthenticated(authenticated);

                                                        //merchantLoginModal(false);
                                                        //history.push('/home');

                                                        props.closeModal([cols[2], event[17], event[21], event[20], cols[0]]);

                                                    }
                                                    else if(cols[2] == "NO_RESPONSE")
                                                    {

                                                        alert('PAYMENT UNSUCESSFUL. '+cols[2]+'.  PLEASE TRY AGAIN');

                                                        clearInterval(intervalID);
                                                        setLoading(false);
                                                        authMerchant_objects.changeAuthenticated(authenticated);
                                                        merchantLoginModal(false);
                                                        props.closeModal([cols[2], event[17]]);


                                                    }
                                                    else
                                                    {
                                                        //alert("PLEASE APPROVE MOMO PAYMENT");

                                                        setLoading(true);
                                                        //clearInterval(intervalID);

                                                    }
                                    
                                                }
                                    
                                            })
            
                  }, 5000); //5 seconds

            // }
            // else
            // {
                //clearTimeout();
            // }

            //props.closeModal();
        })
    }

    function getMomoStatus(event)
    {

        alert('In GetMomoStatus');
        
        alert(event);

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74605_B_retail_public_check_payStatus',
                user: acctID,
                xTransactionID: event,
                sessionID: sessionID,
                
            }),
        }

        fetch(baseURL+'public_to_internal_retail/', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            let rows = data.toString().split('~~~');

            
            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                if(cols[0] == "C" && cols[1] == "SUCCESSFUL")
                {
                    setLoading(false);
                    clearTimeout();
                }
                else
                {
                    
                    setLoading(true);
                }

            }

        })

    }

function handleSubmitPay(event)
{
    setDisablePayButton(true);

    //alert(props.data.status);
    //alert(acctID);

    if(acctID == null)
    {
        //authMerchant_objects.changeAccountID('register_request');
        setSaveEvent(event);
        setRegisterModal_individual(true);
    }
    if(acctID != null)
    {
        submitPay(event, authMerchant_objects.authenticated, acctID);
    }
}

function closeModalHandler() {

    props.payCloseModal(false);
}    

function handleCloseModal(event)
{
    // alert("AFTER REGISTER")
    // alert(event)
    // alert(event[0])
    // alert(event[1])

    setUsername(event[0]);
    setPassword(event[1]);
    setRegisterModal_individual(false);
    setMerchantLoginModal(true);
}

function handleCloseModal_merchantLogin(event)
{
    // alert('handleCloseModal_merchantLogin');
    // alert(event);

    if(event[0] == 'REGISRATION_LOGIN_COMPLETED')
    {
        setIsAuthenticated(event[1]);
        setAcctID(event[2]);
        submitPay(saveEvent, event[1], event[2]);
    }
    else
    {
        alert('LOGIN FAILED, PLEASE TRY AGAIN.');
        //merchantLoginModal(false);
    }
    
}


useEffect(() => {

    //alert(props.data.status);


    if(props.data.status == 'create_order_internal')
    {
        //alert(props.data.status);

        setCheckInCustomerStatus('non_member');
    }
    clearInterval();
}, [])

//alert("in Pay Modal");
// alert(acctID);
// alert(props.data.firstName);
//alert(props.data.paymentType);

return (
    <React.Fragment>
        <IonModal isOpen={ props.openModal }>

            <IonHeader>
                <IonGrid  className='grid_checkInHeader'>
                    <IonRow>
                        <IonCol size="12">
                            <h1> Please Confirm </h1>
                        </IonCol>
                    </IonRow>
                </IonGrid>

            </IonHeader>

            <IonContent className='pay_gridContent'>
 
                <IonGrid >
                    <IonRow>
                        <IonCol className='confirm_pay_left' size="6">
                            First Name: 
                        </IonCol>
                        <IonCol className='confirm_pay_right' size="6">
                            {props.data.firstName}
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol className='confirm_pay_left' size="6">
                            Last Name: 
                        </IonCol>
                        <IonCol className='confirm_pay_right' size="6">
                            {props.data.lastName}
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol className='confirm_pay_left' size="6">
                            MTN Momo Number: 
                        </IonCol>
                        <IonCol className='confirm_pay_right' size="6">
                            {props.data.mobileNumber}
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol className='confirm_pay_left' size="6">
                            Payment Amount: 
                        </IonCol>
                        <IonCol className='confirm_pay_right' size="6">
                            {props.data.payment_amount}
                        </IonCol>
                    </IonRow>
                </IonGrid>

                    {isloading == true && <IonLoading
                        isOpen={isloading}
                        message={'Please wait...'}
                        duration={0} // Show until manually dismissed
                    />}
                
                </IonContent>

                <IonFooter className='pay_footer'>
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                                <IonButton size='4' className='grid_checkInFooter_left' id='gridResultColumnButton'  disabled={disablePayButton} onClick={() => handleSubmitPay([props.data.confirmGuestBookingHandler, props.data.merchantInvoiceID, props.data.customerInvoiceID, props.data.mobileNumber, '74605_checkoutDeposit_retail_public', props.data.payment_amount, props.data.cartList, props.data.firstName, props.data.lastName, props.data.mobileNumber, props.data.clientEmail, props.data.paymentType, props.data.subTotal, props.data.payment_amount, 'initial'])}> Confirm & Pay </IonButton>
                                <IonButton size='4' className='grid_checkInFooter_right' onClick={() => closeModalHandler()}> Cancel </IonButton>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonFooter>

                {registerModal_individial == true && <RegisterIndividualModal  openModal={registerModal_individial} closeModal={(event) => handleCloseModal(event)} payCloseModal={(event) => setRegisterModal_individual(event)} data={{
                                                        source: 'online_pay_register', 
                                                        register_firstName: props.data.firstName,
                                                        register_lastName: props.data.lastName,
                                                        register_phoneNumber: props.data.mobileNumber,
                                                        }}></RegisterIndividualModal>}
                {merchantLoginModal == true && <MerchantLoginCredentials openModal={ merchantLoginModal } closeModal={(event) => handleCloseModal_merchantLogin(event)} payCloseModal={(event) => setMerchantLoginModal(event)} data={{
                                                        source: 'online_pay_register_completed',
                                                        username: username, 
                                                        password: password,
                                                        }}></MerchantLoginCredentials>}

            </IonModal>
    </React.Fragment>)
}